import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../services/notification.service';
import { Notification } from '../../../dtos/notification';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class NotificationBellComponent implements OnInit, OnDestroy {
  @ViewChild('dropdownContainer') dropdownContainer?: ElementRef;

  displayNotifications: Notification[] = [];
  unreadCount = 0;
  isDropdownOpen = false;
  showRead = false;

  private unreadNotifications: Notification[] = [];
  private allNotifications: Notification[] = [];
  private notificationSubscriptions: Subscription[] = [];

  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.notificationSubscriptions.push(
      this.notificationService.unreadNotifications$.subscribe((notifications) => {
        this.unreadNotifications = notifications;
        this.unreadCount = notifications.length;
        if (!this.showRead) {
          this.displayNotifications = notifications;
        }
      }),
    );
    this.notificationSubscriptions.push(
      this.notificationService.allNotifications$.subscribe((notifications) => {
        this.allNotifications = notifications;
        if (this.showRead) {
          this.displayNotifications = notifications;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.notificationSubscriptions.forEach((s) => s.unsubscribe());
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.dropdownContainer && !this.dropdownContainer.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }

  markAsRead(notification: Notification): void {
    if (!notification.isRead) {
      this.notificationService.markAsRead(notification.id).subscribe();
    }
  }

  deleteNotification(notification: Notification, event: Event): void {
    event.stopPropagation();
    this.notificationService.deleteNotification(notification.id).subscribe();
  }

  navigateToNotification(notification: Notification): void {
    this.markAsRead(notification);
    if (notification.actionUrl) {
      this.router.navigate([notification.actionUrl]);
      this.closeDropdown();
    }
  }

  markAllAsRead(): void {
    if (this.unreadCount > 0) {
      this.notificationService.markAllAsRead().subscribe();
    }
  }

  toggleShowRead(): void {
    this.showRead = !this.showRead;
    this.displayNotifications = this.showRead ? this.allNotifications : this.unreadNotifications;
  }

  getNotificationIcon(type: string): string {
    switch (type) {
      case 'GROUP_JOIN_REQUEST':
        return '👥';
      case 'GROUP_REQUEST_ACCEPTED':
        return '✓';
      case 'GROUP_REQUEST_REJECTED':
        return '✕';
      case 'NEW_ASSIGNMENT':
        return '📋';
      case 'GROUP_ANNOUNCEMENT':
        return '📢';
      default:
        return '🔔';
    }
  }

  formatTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;

    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;

    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  }
}
